import { Campaign } from "../../models/Campaign";

export const REQUEST_CAMPAIGNS = "REQUEST_CAMPAIGNS";
export const REQUEST_CAMPAIGNS_DONE = "REQUEST_CAMPAIGNS_DONE";

export interface FetchCampaigns {
  type: typeof REQUEST_CAMPAIGNS;
  payload: ReadonlyArray<Campaign>;
}

export interface FetchCampaignsDone {
  type: typeof REQUEST_CAMPAIGNS_DONE;
  payload: ReadonlyArray<Campaign>;
}

export interface CampaignsState {
  isLoading: boolean;
  campaigns: ReadonlyArray<Campaign>;
}

export type CampaignActions = FetchCampaigns | FetchCampaignsDone;
